import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";

export const useSound = () => {
  const { asistenciasPorConfirmar } = useSelector(
    (state) => state.asistenciasReducer
  );

  const previousLength = useRef(null);

  useEffect(() => {
    const length = asistenciasPorConfirmar.length;

    if (
      previousLength.current !== null &&
      length !== previousLength.current &&
      localStorage.getItem("alertasAsistencias") === "true"
    ) {
      const audio = new Audio(
        length > previousLength.current ? "/entrada.mp3" : "/salida.mp3"
      );

      audio.play().catch(() => {});
    }

    previousLength.current = length;
  }, [asistenciasPorConfirmar.length]);
};
